import { browserHistory } from 'react-router';
import {
  getCookie,
  trackOnboardingStarted,
  trackOnboardingCompleted,
  onboardTrackingConstants,
} from '@zola-helpers/client';
import { submitOnboarding } from '../../../actions/OnboardActions';

// Selectors
import { getUserWeddingDate } from '../../../selectors/user/userSelectors';

const { BUSINESS_UNIT, COMPONENT } = onboardTrackingConstants;

export function callToAction(businessUnitComponent, weddingWebsiteSelected) {
  const selectedWebsiteTheme = getCookie('preauthSelectedWeddingTheme');
  const data = {
    existing_account: true,
    business_unit: businessUnitComponent,
    answers: [],
  };
  if (selectedWebsiteTheme && businessUnitComponent === COMPONENT.WEDDING_WEBSITE) {
    data.wedding_account_details = {
      theme_id: selectedWebsiteTheme,
    };
  }
  return (dispatch, getState) => {
    const state = getState();
    const { userContext } = state.user;
    const weddingDate = getUserWeddingDate(state);
    const goToManage = () => {
      browserHistory.push('/wedding/manage');
    };
    const goToWebsite = () => {
      if (weddingWebsiteSelected) {
        // User has selected a website design before account creation.  Fire these events after the account is created.
        // trackOnboadingStarted for WEDDING_WEBSITE should've been called already upon landing on the designs page.
        trackOnboardingCompleted(BUSINESS_UNIT.WEDDINGS, COMPONENT.WEDDING_WEBSITE, {
          isExistingUser: true,
          weddingDate,
        });
        browserHistory.push('/wedding/manage/website/pages/home');
      } else {
        // User has not selected a website design, tracking events will fire later.
        browserHistory.push('/wedding/manage/website/designs');
      }
    };
    const validateBusinessUnitComponent = () => {
      const validFeatures = [
        COMPONENT.WEDDING_WEBSITE,
        COMPONENT.WEDDING_GUEST_LIST,
        COMPONENT.WEDDING_CHECKLIST,
        COMPONENT.WEDDING_PLANNING,
      ];
      return validFeatures.indexOf(businessUnitComponent) > -1
        ? businessUnitComponent
        : COMPONENT.WEDDING_PLANNING;
    };
    const validBusinessUnitComponent = validateBusinessUnitComponent();
    const handleRedirectForRegistryUser = () => {
      switch (validBusinessUnitComponent) {
        case COMPONENT.WEDDING_WEBSITE:
          goToWebsite();
          break;
        case COMPONENT.WEDDING_GUEST_LIST:
          browserHistory.push('/wedding/manage/guests/all');
          break;
        case COMPONENT.WEDDING_CHECKLIST:
          browserHistory.push('/wedding/manage/wedding-checklist');
          break;
        default:
          goToManage();
      }
    };

    if (userContext.has_wedding_account) {
      return goToManage();
    }
    if (userContext.has_completed_onboarding) {
      return dispatch(submitOnboarding(data)).then(() => {
        trackOnboardingStarted(BUSINESS_UNIT.WEDDINGS, COMPONENT.WEDDINGS, true);
        trackOnboardingCompleted(BUSINESS_UNIT.WEDDINGS, COMPONENT.WEDDINGS, {
          isExistingUser: true,
          weddingDate,
        });
        if (userContext.has_registry) {
          return handleRedirectForRegistryUser();
        }
        // For users without a registry, redirect to the weddings dashboard so they have a chance to register. Except for wedding websites, which are a special case.
        if (validBusinessUnitComponent === COMPONENT.WEDDING_WEBSITE) {
          return goToWebsite();
        }
        return goToManage();
      });
    }
    // User has not onboarded yet - push into the appropriate onboard flow.
    browserHistory.push(`/wedding/onboard?product=${validBusinessUnitComponent}`);
    return undefined;
  };
}



// WEBPACK FOOTER //
// ./src/pages/preauth/util/LandingPageCtaHelper.js